import { EnvironmentSmataInfo } from './environment.model';

export const environment: EnvironmentSmataInfo = {
  name: 'Netstrata',
  production: true,
  envName: 'hotfix',
  apiUrl: 'https://api.ss-edge-hotfix.cloud.netstrata.com.au',
};
